import React, { useMemo } from 'react'
import moment from 'moment'
import { useLocation } from 'react-router-dom'

import TimeSlotTooltip from './TimeSlotTooltip'
import Icon from '../../../components/UI/Icon'

import { calendarTooltips } from '../../../constants'

const COLOR_SCHEME = {
  1: {
    bgColor: 'bg-[#338AF3]',
  },
  2: {
    bgColor: 'bg-success-200',
  },
}

const MonthEvent = ({ data, label, date }) => {
  // data will come from redux without props

  const location = useLocation()

  const isTutor = location.pathname.includes('tutor')

  const timeDetector = useMemo(() => {
    const key = moment(date).format('YYYY-MM-DD')
    // const key = `${moment(value).format('YYYY-MM-DD')}:${moment(value).format('H')}`;

    // const slots = Object.entries(data).filter(([objectKey, value]) => objectKey.includes(key));
    const slots = []

    for (const obejctKey in data) {
      if (obejctKey.includes(key)) {
        slots.push({
          ...data[obejctKey],
          ...COLOR_SCHEME[data[obejctKey].status === 'accepted' ? 2 : 1],
        })
      }
    }

    if (!slots?.length) {
      return
    }

    return slots
  }, [data, label, date])

  return (
    <div className="relative flex flex-col items-center justify-center h-[126px]">
      <span className="month-event-label absolute top-[8px] right-[8px] font-Inter text-[18px] font-semibold leading-[20px] text-primary-100">
        {+label}
      </span>

      <div className="flex flex-col w-full pr-[3px] pl-[8px] gap-y-[4px]">
        {timeDetector &&
          timeDetector.map((item) => {
            const itemTime = item.id.split(':')[1]

            return (
              <div
                key={item.id}
                className={`group w-full h-[18px] flex items-center rounded-[4px] px-[8px] ${item.status === 'pending' ? '' : item.hasInitialEvent ? 'pointer-events-none' : 'cursor-pointer'} ${item.isEmpty ? '' : `${item.bgColor || ''}`}`}
              >
                {!item.isEmpty && (
                  <div className="w-full flex items-center justify-center">
                    <span className="font-bold text-xs text-[#FDFDFD] font-Inter">
                      {item.title}
                    </span>

                    {item.status === 'pending' && (
                      <TimeSlotTooltip
                        title={
                          <span className="text-sm font-medium text-[#F67443] font-Inter whitespace-pre-line">
                            {isTutor ? calendarTooltips.tutor : calendarTooltips.student}
                          </span>
                        }
                      >
                        <div className="ml-[2px]">
                          <Icon
                            name="information-fill"
                            width={12}
                            height={12}
                            className="text-white"
                          />
                        </div>
                      </TimeSlotTooltip>
                    )}

                    {itemTime && (
                      <span className="ml-auto text-[10px] font-medium font-Inter text-[#FDFDFD]">
                        {itemTime}:00
                      </span>
                    )}
                  </div>
                )}
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default MonthEvent
